import { Statuspage } from 'statuspage.io'

// @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
export default new Statuspage(process.env.STATUS_PAGE_ID)
